import React from 'react';
import { Card, Input, Select, Button, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import { CoachFilters as CoachFiltersType } from '../utils/manageCoachUtils';

const { Option } = Select;

interface CoachFiltersProps {
  filters: CoachFiltersType;
  onFiltersChange: (newFilters: CoachFiltersType) => void;
  filteredCount: number;
}

const CoachFilters: React.FC<CoachFiltersProps> = ({
  filters,
  onFiltersChange,
  filteredCount
}) => {
  const handleSearchChange = (value: string) => {
    onFiltersChange({
      ...filters,
      searchText: value,
    });
  };

  const handleStatusChange = (statuses: string[]) => {
    onFiltersChange({
      ...filters,
      statuses,
    });
  };

  const handleSpecializationChange = (specializations: string[]) => {
    onFiltersChange({
      ...filters,
      specializations,
    });
  };

  const clearFilters = () => {
    onFiltersChange({
      searchText: '',
      statuses: [],
      specializations: [],
      clientLoadRanges: [],
      onboardingComplete: undefined,
      certifications: [],
      salaryRanges: [],
      performanceRanges: [],
      retentionRanges: [],
    });
  };

  return (
    <Card title="Filters" size="small">
      <Space direction="vertical" style={{ width: '100%' }} size="middle">
        <Input
          placeholder="Search coaches..."
          prefix={<SearchOutlined />}
          value={filters.searchText}
          onChange={(e) => handleSearchChange(e.target.value)}
          allowClear
        />
        
        <Select
          mode="multiple"
          placeholder="Filter by status"
          style={{ width: '100%' }}
          value={filters.statuses}
          onChange={handleStatusChange}
        >
          <Option value="Active">Active</Option>
          <Option value="Inactive">Inactive</Option>
          <Option value="Onboarding">Onboarding</Option>
        </Select>

        <Select
          mode="multiple"
          placeholder="Filter by specializations"
          style={{ width: '100%' }}
          value={filters.specializations}
          onChange={handleSpecializationChange}
        >
          <Option value="Strength Training">Strength Training</Option>
          <Option value="Weight Loss">Weight Loss</Option>
          <Option value="Yoga">Yoga</Option>
          <Option value="Athletic Performance">Athletic Performance</Option>
          <Option value="Sports Training">Sports Training</Option>
        </Select>

        <Space style={{ width: '100%', justifyContent: 'space-between' }}>
          <Button
            icon={<ClearOutlined />}
            onClick={clearFilters}
            size="small"
          >
            Clear All
          </Button>
          <span style={{ fontSize: '12px', color: '#666' }}>
            {filteredCount} coaches found
          </span>
        </Space>
      </Space>
    </Card>
  );
};

export default CoachFilters; 